import { Point } from "../models/Point";
import { EncodingUtils } from "../utils/EncodingUtils";
import { SvgUtils } from "../utils/SvgUtils";
import { VisualizerBase } from "./VisualizerBase";
import { PathDataUtility } from "../utils/PathDataUtility";

export class ArbNova extends VisualizerBase {
    constructor(_placeholderMode: boolean = false) {
        super("arbNova", _placeholderMode);
    }

    gengrateSign() {
        const groupSign = document.createElementNS("http://www.w3.org/2000/svg", "g");
        //const transform = `translate(-36.5, -43)`;
        // const sign1Data = PathDataUtility.adjust(
        //     `M28.7877 24.3143H24.8335C24.5361 24.3143 24.2725 24.5049 24.1711 24.8013L11.457 61.1916C11.3758 61.4316 11.5448 61.6857 11.7882 61.6857H15.7423C16.0397 61.6857 16.3033 61.4951 16.4047 61.1987L29.1189 24.8013C29.2 24.5684 29.031 24.3143 28.7877 24.3143Z`,
        //     pos);
        // const sign1 = SvgUtils.createPath2("", sign1Data, false, signColor, "", 0);
        // groupSign.appendChild(sign1);

        // const sign2Data = `M33.9044 38.423C33.7895 38.0983 33.3569 38.0983 33.242 38.423L31.1872 44.3093C31.1331 44.4716 31.1331 44.648 31.1872 44.8174L36.9123 61.2058C37.0137 61.4951 37.2773 61.6928 37.5747 61.6928H41.5289C41.7722 61.6928 41.9412 61.4387 41.8601 61.1987L33.9044 38.423Z`;
        // const sign2 = SvgUtils.createPath2("", sign2Data, false, transform, color2, "", 0);
        // groupSign.appendChild(sign2);

        const sign3Data = `M35.6957 24.3143H31.7415C31.4441 24.3143 31.1805 24.5049 31.0791 24.8013L18.3717 61.1916C18.2906 61.4316 18.4595 61.6857 18.7029 61.6857H22.657C22.9545 61.6857 23.2181 61.4951 23.3194 61.1987L36.0336 24.8013C36.1147 24.5684 35.9457 24.3143 35.6957 24.3143Z`;
        const color3 = this.getColorHex(0, 1, 2);
        const sign3 = SvgUtils.createPath("", sign3Data, false, color3, "", 0);
        groupSign.appendChild(sign3);

        const color4 = this.getColorHex(9, 10, 11);
        const sign4Data = `M37.3584 28.5279C37.2435 28.2032 36.8109 28.2032 36.696 28.5279L34.6412 34.4141C34.5871 34.5764 34.5871 34.7529 34.6412 34.9223L43.8271 61.2057C43.9284 61.4951 44.1921 61.6927 44.4895 61.6927H48.4436C48.687 61.6927 48.8559 61.4386 48.7748 61.1987L37.3584 28.5279Z`;
        const sign4 = SvgUtils.createPath("", sign4Data, false, color4, "", 0);
        groupSign.appendChild(sign4);

        const color5 = this.getColorHex(17, 18, 19);
        const sign5Data = `M61.2119 24.3143H57.2577C56.9603 24.3143 56.6967 24.5049 56.5953 24.8013L47.4162 51.0848C47.3621 51.2471 47.3621 51.4236 47.4162 51.593L49.471 57.4792C49.5859 57.8039 50.0185 57.8039 50.1334 57.4792L61.5431 24.8154C61.6309 24.5684 61.4552 24.3143 61.2119 24.3143Z`;
        const sign5 = SvgUtils.createPath("", sign5Data, false, color5, "", 0);
        groupSign.appendChild(sign5);

        // const sign6Data = `M46.017 47.577C46.132 47.9017 46.5645 47.9017 46.6795 47.577L54.6351 24.8084C54.7162 24.5684 54.5472 24.3143 54.3039 24.3143H50.3497C50.0523 24.3143 49.7887 24.5049 49.6873 24.8013L43.9622 41.1897C43.9082 41.352 43.9082 41.5284 43.9622 41.6978L46.017 47.577Z`;
        // const sign6 = SvgUtils.createPath2("", sign6Data, false, transform, color6, "", 0);
        // groupSign.appendChild(sign6);

        return groupSign;
    }
    
    public override generate(hex: string, coreMode: boolean = false): SVGSVGElement {
        const svg = this.createSvg();
        //this.appendBlendStyle(svg);
        this.hexArray = EncodingUtils.hexStringToHexArray(hex);

        const size = 320;
        const center = size / 2;
        const R = 40;
        const r0 = 100;
        const height = 40, halfH = height / 2;
        const pX = halfH * Math.tan(24 * Math.PI / 180);

        const defs = document.createElementNS("http://www.w3.org/2000/svg", "defs");

        const color1 = this.getColorHex(1, 2, 3);
        const color2 = this.getColorHex(4, 5, 6);
        const color3 = this.getColorHex(7, 8, 9);
        
        const idOB = `circleOutbounding_${this.chainIdName}`;
        const dOB = SvgUtils.getDOfPathOfCircle(0, 0, 150);
        const obCircle = document.createElementNS("http://www.w3.org/2000/svg", "path");
        obCircle.id = idOB;
        obCircle.setAttribute("d", `${dOB}`);
        defs.appendChild(obCircle);

        const idHexagram = `hexagram_big_${this.chainIdName}`;
        // width="73" height="86" viewBox="0 0 73 86"
        // const hexaData = PathDataUtility.adjust(
        //     `M36.5 5.32868C36.696 5.32868 36.892 5.38515 37.0678 5.48396L67.329 23.7285C67.6805 23.9403 67.8968 24.3355 67.8968 24.7519V61.234C67.8968 61.6574 67.6805 62.0456 67.329 62.2574L37.0678 80.5019C36.8988 80.6078 36.696 80.6572 36.5 80.6572C36.304 80.6572 36.108 80.6007 35.9322 80.5019L5.67102 62.2715C5.31954 62.0597 5.10324 61.6645 5.10324 61.2481V24.759C5.10324 24.3355 5.31954 23.9473 5.67102 23.7356L35.9322 5.49101C36.108 5.38515 36.304 5.32868 36.5 5.32868ZM36.5 0C35.4253 0 34.3438 0.289372 33.3772 0.875174L3.12278 19.1127C1.18963 20.2772 0 22.4299 0 24.759V61.241C0 63.5701 1.18963 65.7228 3.12278 66.8873L33.384 85.1319C34.3506 85.7106 35.4253 86.007 36.5068 86.007C37.5882 86.007 38.663 85.7177 39.6295 85.1319L69.8907 66.8873C71.8239 65.7228 73.0135 63.5701 73.0135 61.241V24.759C73.0135 22.4299 71.8239 20.2772 69.8907 19.1127L39.6228 0.875174C38.6562 0.289372 37.5747 0 36.5 0Z`,
        //     new Point(-36.5, -r0 - 43));
        const hexaData = `M36.5 5.32868C36.696 5.32868 36.892 5.38515 37.0678 5.48396L67.329 23.7285C67.6805 23.9403 67.8968 24.3355 67.8968 24.7519V61.234C67.8968 61.6574 67.6805 62.0456 67.329 62.2574L37.0678 80.5019C36.8988 80.6078 36.696 80.6572 36.5 80.6572C36.304 80.6572 36.108 80.6007 35.9322 80.5019L5.67102 62.2715C5.31954 62.0597 5.10324 61.6645 5.10324 61.2481V24.759C5.10324 24.3355 5.31954 23.9473 5.67102 23.7356L35.9322 5.49101C36.108 5.38515 36.304 5.32868 36.5 5.32868ZM36.5 0C35.4253 0 34.3438 0.289372 33.3772 0.875174L3.12278 19.1127C1.18963 20.2772 0 22.4299 0 24.759V61.241C0 63.5701 1.18963 65.7228 3.12278 66.8873L33.384 85.1319C34.3506 85.7106 35.4253 86.007 36.5068 86.007C37.5882 86.007 38.663 85.7177 39.6295 85.1319L69.8907 66.8873C71.8239 65.7228 73.0135 63.5701 73.0135 61.241V24.759C73.0135 22.4299 71.8239 20.2772 69.8907 19.1127L39.6228 0.875174C38.6562 0.289372 37.5747 0 36.5 0Z`;
        const hexagram = SvgUtils.createPath2(idHexagram, hexaData, true, `translate(-36.5 ${-r0 - 43})`, "", "", 0);
        defs.appendChild(hexagram);

        const points: Array<Point> = [ new Point(0, -r0 + halfH),
            new Point(-pX, -r0),
            new Point(0, -r0 - halfH),
            new Point(pX, -r0)
        ];
        const polygonId = `polygon_48deg_80_${this.chainIdName}`;
        const polygon = SvgUtils.createPolygonPath(polygonId, points, true, ``, "", 0);
        defs.appendChild(polygon);

        svg.appendChild(defs);

        if(!coreMode) {
            // outbound: moving 3 circles
            this.appendMovingCirclesOutbound(svg, 150);
            // outbound: scaling circle
            this.appendDynamicScalingOutbound(svg, 1.4);
        }

        const group = document.createElementNS("http://www.w3.org/2000/svg", "g");
        // 0: rotate
        const angle = this.placeholderMode ? 0 : parseInt(this.hexArray[0], 16);

        // big-1
        this.addUsePartToGroup(group, idHexagram, ``, color1, "", 0);
        // big-2
        this.addUsePartToGroup(group, idHexagram, `rotate(120,0,0)`, color2, "", 0);
        // big-3
        this.addUsePartToGroup(group, idHexagram, `rotate(240,0,0)`, color3, "", 0);

        // small-1
        const color4 = this.getColorHex(10, 11, 12);
        this.addUsePartToGroup(group, polygonId, "rotate(60,0,0)", color4, "", 0);
        // // small-2
        const color5 = this.getColorHex(13, 14, 15);
        this.addUsePartToGroup(group, polygonId, "rotate(180,0,0)", color5, "", 0);
        // // small-3
        const color6 = this.getColorHex(16, 17, 18);
        this.addUsePartToGroup(group, polygonId, "rotate(300,0,0)", color6, "", 0);

        group.setAttribute("transform", `rotate(${angle},${center},${center}) translate(${center} ${center})`);
        svg.appendChild(group);

        // sign
        const groupSign = this.gengrateSign(); // translate(-36.5, -43)
        groupSign.setAttribute("transform", `translate(${center - 36.5} ${center - 43})`);
        svg.appendChild(groupSign);
        return svg;
    }

}